/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedEmployeePostsHierarchyDropdown200,
  GetApiV1PersonSharedEmployeePostsHierarchyDropdown401,
  GetApiV1PersonSharedEmployeePostsHierarchyDropdown500,
  GetApiV1PersonSharedEmployeePostsHierarchyDropdownQueryParams,
  GetApiV1PersonSharedEmployeePostsHierarchyDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedEmployeePostsHierarchyDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonSharedEmployeePostsHierarchyDropdownQueryParamsSchema =
  z
    .object({
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1PersonSharedEmployeePostsHierarchyDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedEmployeePostsHierarchyDropdown200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1PersonSharedEmployeePostsHierarchyDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedEmployeePostsHierarchyDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedEmployeePostsHierarchyDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedEmployeePostsHierarchyDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedEmployeePostsHierarchyDropdown500>;

export const getApiV1PersonSharedEmployeePostsHierarchyDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedEmployeePostsHierarchyDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedEmployeePostsHierarchyDropdownQueryResponse>;
